if (!customElements.get('checkout-action')) {
    class CheckoutAction extends HTMLElement {

        constructor() {
            super();
            this._loading = false;
            this._submitting = false;
            this.submit = this.querySelector('button');

            this._boundMethods = {
                handleSubmit: this.handleSubmit.bind(this),
                requestLoadingStart: this.requestLoadingStart.bind(this),
                requestLoadingEnd: this.requestLoadingEnd.bind(this),
            };
        }

        get loading() { return this._loading; }

        set loading(value) {
            if (this._loading == value) return;
            this._loading = value;
            this.submit.disabled = value;
            this.submit.setAttribute('aria-disabled', `${value}`);

            this.submit.classList.toggle('is-loading', value);
            document.body.classList.toggle('checkout-loading', value);
        }

        connectedCallback() {
            this.submit.addEventListener('click', this._boundMethods.handleSubmit);
            document.addEventListener('request:loading:start', this._boundMethods.requestLoadingStart);
            document.addEventListener('request:loading:end', this._boundMethods.requestLoadingEnd);
        }

        disconnectedCallback() {
            this.submit.removeEventListener('click', this._boundMethods.handleSubmit);
            document.removeEventListener('request:loading:start', this._boundMethods.requestLoadingStart);
            document.removeEventListener('request:loading:end', this._boundMethods.requestLoadingEnd);
        }

        requestLoadingStart() {
            this.loading = true;
        }

        requestLoadingEnd() {
            // Ignore the intermediate `request:loading:end` the checkout
            // component emits while our own submit is still in flight. Only the
            // finally block below ends this button's loading state.
            if (this._submitting) return;
            this.loading = false;
        }

        async handleSubmit(e) {

            if (this._submitting) {
                console.log('⚠️ checkout-action: submit already in progress - ignoring click.');
                return;
            }
            this._submitting = true;

            // Start loading
            document.dispatchEvent(new CustomEvent('request:loading:start', { bubbles: true}));

            try {
                document.querySelectorAll(`.cart-items tr`).forEach((row) => row.classList.remove('selected'));

                const { items } = LocalCart.getState();
                const alternatives = items.filter(({ properties }) => {
                    const isHidden = Object.keys(properties).includes('_hidden');
                    const isAlternative = Object.keys(properties).includes('_is_alternative_product');
                    const unresolved = properties._resolved != true;
                    return isAlternative && unresolved && !isHidden;
                });

                // The stock level check is a one-shot step: it validates the
                // replacements the customer picked. Once it has run for this
                // checkout, every submit approves - acting on the result screen
                // or leaving it untouched both lead to approve. Re-running it
                // returned the same answer and rebuilt the same screen, so the
                // button appeared to do nothing.
                const alreadyChecked = window.checkout.hasStockLevelCheckRun();

                console.log(`Alternatives products (From component-checkout-action.js) >>`, alternatives, `| stock level check already run >>`, alreadyChecked);

                (alternatives.length && !alreadyChecked)
                    ? await window.checkout.handleStockLevelCheck()
                    : await window.checkout.handleApprove();
            } finally {
                // End loading. Clear our own state first: a cart re-render
                // detaches this element, and a detached listener would no
                // longer react to the event below - leaving `checkout-loading`
                // stuck on <body>.
                this._submitting = false;
                this.loading = false;
                document.dispatchEvent(new CustomEvent('request:loading:end', {bubbles: true}));
            }

        }
    }

    customElements.define('checkout-action', CheckoutAction);
}
